import { EventHelper } from "app/helpers/eventHelper";
import type { EventRunnerType, EventType } from "app/types/eventType";
import { EventStatus } from "app/utils/const";
import { runnersDict } from "../../helpers/runnersDictHelper";
import RunnerElement from "../RunnerElement/RunnerElement";

type CreateRunnerElementsParams = {
  runners: EventRunnerType[];
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  market: Record<string, any>;
  props: {
    event: EventType;
    addBetSlip: Function;
    market: Record<string, any>;
    highestNumberOfMarkets: number;
    line: string;
    row?: boolean;
  };
};

export const CreateRunnerElements = ({
  runners,
  event,
  addBetSlip,
  market,
  props,
}: CreateRunnerElementsParams) => {
  runners.forEach((runner: EventRunnerType) => {
    if (
      runner.status === EventStatus.CLOSED ||
      runner.status === EventStatus.GRADED
    ) {
      runnersDict[runner.side] = null;
      return;
    }

    const highestOdds = runner?.aggregatedPrices?.length
      ? EventHelper.getHighestOddsValueFrom(runner.aggregatedPrices)
      : null;

    runnersDict[runner.side] = (
      <RunnerElement
        key={runner.id}
        runner={runner}
        event={event}
        highestOdds={highestOdds}
        addBetSlip={addBetSlip}
        marketType={market.type}
        props={props}
      />
    );
  });
};
